export default "__VITE_ASSET__DuAew9BY__"